// Sticky header
let header = document.getElementById("masthead");
let scrollPosition = document.documentElement.scrollTop;

if (scrollPosition > 0) {
	header.classList.add("scroll");
}

document.addEventListener("DOMContentLoaded", function () {
	window.addEventListener("scroll", function () {
		if (document.documentElement.scrollTop >= 1) {
			header.classList.add("scroll");
		} else {
			header.classList.remove("scroll");
		}
	});
});
